import React, { createContext, useState } from "react";
export const AdvancedOptionsContext = createContext(null);
export const AdvancedOptionsProvider = ({ children = void 0 }) => {
  const [isAdvancedOptionsVisible, setAdvancedOptionsVisibility] = useState(false);
  return /* @__PURE__ */ React.createElement(
    AdvancedOptionsContext.Provider,
    {
      value: {
        isAdvancedOptionsVisible,
        setAdvancedOptionsVisibility
      }
    },
    children
  );
};
